import {Component, Input} from "@angular/core";
import {Observable} from "rxjs";

@Component({
	selector: "fly-loading",
	template: `
		<div *ngIf="loading" class="loading-indicator">{{message}}</div>
	`,
})
export class LoadingComponent {
	loading = true;

	@Input() message = "Loading...";

	@Input() set when(condition: any) {
		this.loading = !!condition;
	}

	@Input() set unless(condition: any) {
		this.loading = !condition;
	}

	@Input() set until(resolvable: Observable<any> | Promise<any>) {
		let loaded = () => {
			this.loading = false;
		};

		if (resolvable instanceof Observable)
			resolvable = resolvable.toPromise();

		resolvable.then(loaded, loaded);
	}
}
